import { ArrowLeft, ArrowRight } from 'lucide-react';
import type { User } from '../types';
import { AvatarGroup } from './UserAvatar';
import './ItineraryBranches.css';

/** One line treatment for branch changes and travellers joining/leaving the trip. */
export function ItineraryJunctionLine({ label, people, rejoining = false, inset = false, onOpen }: {
  label: string; people: User[]; rejoining?: boolean; inset?: boolean; onOpen?: () => void;
}) {
  const text = <><span className="itinerary-branch-line-text" title={label}>{label}</span>
    {rejoining ? <ArrowLeft size={16} aria-hidden="true" /> : <ArrowRight size={16} aria-hidden="true" />}</>;
  const caption = onOpen
    ? <button type="button" className="itinerary-branch-link itinerary-branch-line-label" onClick={onOpen}>{text}</button>
    : <span className="itinerary-branch-line-label">{text}</span>;
  return <div className={`itinerary-branch-junction${inset ? ' itinerary-branch-junction-inset' : ''}`}>
    {!inset && <svg aria-hidden="true" viewBox="0 0 64 100" preserveAspectRatio="none"><path vectorEffect="non-scaling-stroke" d={rejoining
      ? 'M64 50 C40 50 24 65 24 90 V100'
      : 'M24 0 C24 35 40 50 64 50'} /></svg>}
    <div className={`itinerary-branch-line-content${rejoining ? ' rejoining' : ''}`}>
      {rejoining && caption}
      <div className="itinerary-branch-people"><AvatarGroup users={people} size={32} max={2} tapToReveal /></div>
      {!rejoining && caption}
    </div>
  </div>;
}
